import { useActiveWeb3React } from './index'
import { ChainId } from '@uniswap/sdk'

export default function useOmniChain(): boolean {
  const { chainId } = useActiveWeb3React()

  return chainId === ChainId.OMNI_TESTNET
}
